import React, { useState, useReducer, useEffect } from "react";
import { Button, Form, Modal, Icon } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import { columnDefs, defaultColDef } from "./GridParamsColumn1/GridParams";
import { columnDefs2, defaultColDef2 } from "./GridParamsColumn2/GridParams";
import { columnDefs3, defaultColDef3 } from "./GridParamsColumn3/GridParams";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  // const [SelectedCategorie, setSelectedCategorie] = useState("");
  // const [SelectedCategorieText, setSelectedCategorieText] =
  //   useState("Acte Proposé");
  // ag grid state
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const { ID, syncData, option, AuthState } = props;

  async function getOneUser() {
    await axios
      .get(`${server}Btn_First_Column/${option}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({
          type: "FETCH_SUCCESS",
          payload: response.data,
          title: response.data[0].Nom_CategoryBtn,
        });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  async function getOneUser2() {
    if (state.id_detail_1 > 0 && option > 0) {
      await axios
        .get(`${server}Btn_Second_Column/${option}/${state.id_detail_1}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: "FETCH_ERROR", payload: error.response });
        });
    } else {
      dispatch({ type: ACTION.FETCH_SUCCESS2, payload: [] });
    }
  }

  async function getOneUser3() {
    if (state.id_detail_2 && state.id_detail_1 && option) {
      await axios
        .get(
          `${server}Btn_Third_Column/${option}/${state.id_detail_1}/${state.id_detail_2}`,
          {
            headers: {
              jwtoken: sessionStorage.token,
            },
          }
        )
        .then((response) => {
          dispatch({ type: ACTION.FETCH_SUCCESS3, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: "FETCH_ERROR", payload: error.response });
        });
    } else {
      dispatch({ type: ACTION.FETCH_SUCCESS3, payload: [] });
    }
  }

  function SetEyeValOG() {
    if (state.Nom_Detail_1 && !state.Nom_Detail_2 && !state.Nom_Detail_3) {
      let EyeVal = state.Nom_Detail_1;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
        payload: `${state.og ? state.og : ""} - ${EyeVal}`,
      });
    } else if (
      state.Nom_Detail_1 &&
      state.Nom_Detail_2 &&
      !state.Nom_Detail_3
    ) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
        payload: `${state.og ? state.og : ""} - ${EyeVal}`,
      });
    } else if (state.Nom_Detail_1 && state.Nom_Detail_2 && state.Nom_Detail_3) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2} ${state.Nom_Detail_3}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
        payload: `${state.og ? state.og : ""} - ${EyeVal}`,
      });
    }
  }

  function SetEyeValOD() {
    if (state.Nom_Detail_1 && !state.Nom_Detail_2 && !state.Nom_Detail_3) {
      let EyeVal = state.Nom_Detail_1;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    } else if (
      state.Nom_Detail_1 &&
      state.Nom_Detail_2 &&
      !state.Nom_Detail_3
    ) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    } else if (state.Nom_Detail_1 && state.Nom_Detail_2 && state.Nom_Detail_3) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2} ${state.Nom_Detail_3}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    }
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  useEffect(() => {
    getOneUser2();
    // dispatch({ type: ACTION.FETCH_SUCCESS3, payload: [] });
  }, [state.id_detail_1]);

  useEffect(() => {
    getOneUser3();
  }, [state.Nom_Detail_2]);

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: state.og,
      od: state.od,
      fk_id_examen: 8,
      observation: state.observation,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        fk_id_categoryBtn: "",
        id_detail_1: "",
      };
      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: clientArray,
      });
    }
  };
  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        Nom_Detail_2: "",
        fk_id_categoryBtn: "",
        fk_id_detail_1: "",
        id_detail_2: "",
      };
      dispatch({
        type: ACTION.LOAD_SECOND_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch({
        type: ACTION.LOAD_SECOND_TABLE,
        value: clientArray,
      });
    }
  };
  const onSelectionChanged3 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        Nom_Detail_2: "",
        Nom_Detail_3: "",
        fk_id_categoryBtn: "",
        fk_id_detail_1: "",
        id_detail_2: "",
        id_detail_3: "",
      };
      dispatch({
        type: ACTION.LOAD_THIRD_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch({
        type: ACTION.LOAD_THIRD_TABLE,
        value: clientArray,
      });
    }
  };

  const onCellValueChanged = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Btn_First_Column`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        // dispatch({ type: ACTION.FETCH_SUCCESS, payload: response.data });
        dispatch({
          type: ACTION.LOAD_FIRST_TABLE,
          value: data,
        });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const onCellValueChanged2 = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Btn_Second_Column`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        // dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
        dispatch({
          type: ACTION.LOAD_SECOND_TABLE,
          value: data,
        });
        getOneUser2();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const onCellValueChanged3 = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Btn_Third_Column`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        // dispatch({ type: ACTION.FETCH_SUCCESS3, payload: response.data });
        dispatch({
          type: ACTION.LOAD_THIRD_TABLE,
          value: data,
        });
        getOneUser3();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Btn_First_Column/${state.fk_id_categoryBtn}/${state.id_detail_1}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };
  const handleRemoveItem2 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Btn_Second_Column/${state.fk_id_categoryBtn}/${state.id_detail_1}/${state.id_detail_2}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        getOneUser2();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };
  const handleRemoveItem3 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Btn_Third_Column/${state.fk_id_categoryBtn}/${state.id_detail_1}/${state.id_detail_2}/${state.id_detail_3}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        getOneUser3();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  return (
    <>
      <Button

        color="purple"
        onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
      >
        ANGIO
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => {
          // setSelectedCategorie("")
          dispatch({ type: ACTION.CLOSE });
        }}
      >
        <Modal.Header className="center3columnheaders">ANGIO</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Button negative onClick={handleRemoveItem1} icon>
                <Icon name="delete" />
              </Form.Button>
              <Form.Button negative onClick={handleRemoveItem2} icon>
                <Icon name="delete" />
              </Form.Button>
              <Form.Button negative onClick={handleRemoveItem3} icon>
                <Icon name="delete" />
              </Form.Button>
            </Form.Group>
            <Form.Group widths="equal">
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "33.3%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData ? state.rowData : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                ></AgGridReact>
              </div>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "33.3%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "33.3%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData3 ? state.rowData3 : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs3}
                  defaultColDef={defaultColDef3}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged3}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged3}
                ></AgGridReact>
              </div>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Button width={1} onClick={() => SetEyeValOD()}>
                OD
              </Form.Button>
              <Form.TextArea
                autoFocus
                rows={2}
                width={4}
                value={state.od}
                placeholder="Formulaire réservé à l'oeil droit"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
                    payload: data.value,
                  })
                }
              />
              <Form.Button width={1} onClick={() => SetEyeValOG()}>
                OG
              </Form.Button>
              <Form.TextArea
                rows={2}
                width={4}
                value={state.og}
                placeholder="Formulaire réservé à l'oeil gauche"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
                    payload: data.value,
                  })
                }
              />
              <Form.Button color="blue" width={1} onClick={() => { SetEyeValOG(); SetEyeValOD() }}>
                ODG
              </Form.Button>
              <Form.TextArea
                rows={2}
                width={4}
                placeholder="Formulaire réservé aux observations"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
                    payload: data.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="blue"
            onClick={() => {
              // setSelectedCategorie("")
              dispatch({ type: ACTION.CLOSE });
            }}
          >
            Retour
          </Button>
          <Button positive onClick={onValueChanged}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
